export default __webpack_public_path__ + "static/media/YT.49693a5f.svg";